module.exports = __webpack_public_path__ + "img/fission-banner.aa09343f.png";